import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { API } from './api';
import { SbDateTime, SbLocalDate, SbLocalDateTime, SbLocalTime } from './api-date-time';

@Injectable()
export class ConversionService {
  constructor(private api: API) {}

  public prepareObject(prepared) {
    if (prepared) {
      if (Array.isArray(prepared)) {
        for (let key in prepared) prepared[key] = this.singleObjectPrepare(prepared[key]);
      } else {
        prepared = this.singleObjectPrepare(prepared);
      }
    }
    return prepared;
  }

  private singleObjectPrepare(prepared) {
    if (prepared._type) {
      let dto = this.api.createDTO(prepared._type);
      if (dto) {
        this.api.copy(prepared, dto);
        prepared = dto;
      }
      for (let field in prepared) {
        prepared[field] = this.prepareObject(prepared[field]);
      }
    } else if (typeof prepared === 'object') {
      for (let field in prepared) {
        prepared[field] = this.prepareObject(prepared[field]);
      }
    } else if (typeof prepared === 'string') {
      if (
        /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?((Z)|((\+|\-)[0-9][0-9]:[0-9][0-9]))?$/.test(
          prepared
        )
      ) {
        const dt = DateTime.fromISO(prepared);
        let isLocal = true;
        if (/[+-][0-9]{2}:[0-9]{2}\b|(Z)$/.test(prepared)) {
          isLocal = false;
        }
        if (isLocal) {
          prepared = new SbLocalDateTime();
        } else {
          prepared = new SbDateTime();
        }
        prepared.value = dt;
      }
      if (/^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])?$/.test(prepared)) {
        const dt = DateTime.fromISO(prepared);
        prepared = new SbLocalDate();

        prepared.value = dt;
        return prepared;
      }
      if (/^(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?((Z)|((\+|\-)[0-9][0-9]:[0-9][0-9]))?$/.test(prepared)) {
        prepared = SbLocalTime.fromIso(prepared);
      }
    }
    return prepared;
  }
}
